import { combineReducers } from 'redux';

import screen from './reducers/wordCityScreenReducer';
import gameDetails from './reducers/wordCityGameDetailsReducer';
import curriculum from './reducers/wordCityCurriculumReducer';
import standardRound from './reducers/wordCityStandardRoundReducer';
import standardStep from './reducers/wordCityStandardStepReducer';
import narration from './reducers/wordCityNarrationReducer';
import gameMode from './reducers/wordCityGameModeReducer';
import onboardingRound from './reducers/wordCityOnboardingRoundReducer';
import feedback from './reducers/wordCityFeedbackReducer';

const reducers = combineReducers({
  screen,
  gameDetails,
  curriculum,
  standardRound,
  standardStep,
  narration,
  gameMode,
  onboardingRound,
  feedback,
});

export default reducers;
